import { ConfigLabelSelect } from '../adapter/ConfigLabelSelect';

type Props = {
  value: string;
  onChange: (label: string) => void;
  disabled?: boolean;
  /** When true, only existing labels can be selected; empty value is allowed. */
  selectOnly?: boolean;
};

export function AdapterConfigLabelField({ value, onChange, disabled, selectOnly = false }: Props) {
  return (
    <ConfigLabelSelect
      selectOnly={selectOnly}
      value={value}
      onChange={onChange}
      disabled={disabled}
      helperText="adapter_configs.label — publish namespace. Same adapter key is allowed with a different label (uniqueness is key + label)."
    />
  );
}
